module.exports = __webpack_public_path__ + "assets/events_election_blue.d49ff183.svg";